var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"canvas_main",staticClass:"absolute overlay canvas canvas--main"}),_c('canvas',{ref:"canvas_temp",staticClass:"absolute overlay canvas canvas--temp"})])}
var staticRenderFns = []

export { render, staticRenderFns }